<template lang="pug">
section
  header.header-settings
    .tabs
      .tab.primary-text.active
        span Billing
  div

  div(v-if="company.isExpired")
    .animation
      LottieAnimation(svg="expired", :width="300", :height="300")

    AlertBox.center(type="danger", :text="alertText")

  .row.justify-center
    .col
      a.plan-link(@click="cycle = 'month'", :class="{ selected: cycle === 'month' }") Monthly
    .col
      a.plan-link(@click="cycle = 'year'", :class="{ selected: cycle === 'year' }") Yearly
  .row.gap-2.wrapped
    .col.max.fixed-plan(v-for="thisPlan in planOptions")
      .plan
        .plan-icon
          img(v-if="thisPlan.code === 'watcher'", src="../../../assets/images/watcher-icon-2.svg")
          img(v-if="thisPlan.code === 'lookout'", src="../../../assets/images/lookout-icon-2.svg")
        .plan-name {{thisPlan.name}}
        .plan-cost ${{thisPlan.cost}}/{{thisPlan.cycle}}
        .plan-description
          p {{ planDetails[thisPlan.code].description }}
        span.button(v-if="subscription && subscription.plan.vendorId === thisPlan.vendorId")
          span Your Plan
        .row(v-else)
          .col
            a.button.primary-button(class="paddle_button", @click="getCheckoutLink(thisPlan._id)" :data-product="thisPlan.vendorId")
              span(v-if="subscription") Change Plan
              span(v-else) Purchase Plan
          .col
            a.button.button-none(href="https://www.feature.watch/pricing", target="_blank") View Features
    .col.max.custom-plan
      .plan
        .row.gap-2
          .col
            .plan-icon
              img(src="../../../assets/images/sentinel-icon-2.svg")
          .col.max
            .plan-name Sentinel
            .plan-description
              p Need the best of the best of the best? Then this plan is for you!
            .row
              .col
                a.button.primary-button(href="https://feature.watch/contact", target="_blank")
                  span Contact Us
              .col
                a.button.button-none(href="https://feature.watch/pricing", target="_blank") View Features

  AlertBox(v-if="subscription", type="danger", text="If you'd like to cancel your subscription for some ludicrious reason please contact support@feature.watch.")
</template>

<script>

import LottieAnimation from '@/components/helpers/LottieAnimation'

import { mapState } from 'vuex'

const planDetails = {
  watcher: {
    icon: 'watcher-icon-2.svg',
    description: 'Our Watcher plan will help your business gather feedback from your users.'
    },
  lookout: {
    icon: 'lookout-icon-2.svg',
    description: 'Need a bit more versatility? Our Lookout plan offers your company some powerful features.'
  }
}

export default {
  name: 'SettingsBilling',
  components: {
    LottieAnimation
  },
  mounted () {
  },
  data() {
    return {
      planDetails,
      cycle: 'month'
    }
  },
  computed: {
    ...mapState({
      plans: state => state.plans,
      user: state => state.user,
      company: state => state.company,
      subscription: state => state.subscription
    }),
    planOptions() {
      return this.plans.filter(plan => plan.cycle === this.cycle)
    },
    alertText () {
      let text = ''
      if (this.company.trialDaysRemaining > 0) {
        text = `You have ${this.company.trialDaysRemaining} day${this.company.trialDaysRemaining > 1 ? 's' : ''} left on your trial. Choose a plan to upgrade now.`
      } else {
        text = 'Time\'s Up. Your Trial has expired. Choose a plan below to continue.'
      }
      return text
    }
  },
  methods: {
    getCheckoutLink(planId) {
      this.$axios.get(`integration/stripe/checkout-session?planId=${planId}`)
        .then(result => {
          console.log(result.data)
          if (result.data.url) {
            window.location.href = result.data.url
          } else {
            window.location.reload()
          }
        })
    },
    submit () {
      console.log("submitted")
      console.log(this.form)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .center
    text-align center
  .plan
    border $border-default
    padding $spacing-3
    .plan-icon
      margin-bottom 30px
    .plan-name
      margin-bottom 15px
    .plan-cost
      color $color-primary
      font-size 26px
      margin-bottom 15px
    .plan-description
      color $text-light
      font-size $text-size-smaller
      margin-bottom 15px

    .button-none
      color $text-unselected
  .fixed-plan
    width 50%
    min-width 50%
  .custom-plan
    width 100%

  a.plan-link
    border-bottom 1px solid $text-unselected
    color $text-unselected
    cursor default
    display inline-block
    margin $spacing-2
    padding 8px 15px
    text-align center
    width 100px
    &:not(.selected)
      cursor pointer
    &.selected
      border-color $color-primary
      color $color-primary
</style>
